// BBQ Assador — Casa de Petiscos · carta completa
// tag: "popular" | "recomendado" | "especialidade"

export const BBQ_FEATURED = [
  {
    name: "Picanha",
    price: "17,90",
    tag: "especialidade",
    category: "Carnes",
    note: "Selada na grelha, ao ponto. Corte nobre.",
  },
  {
    name: "Costeletas de Borrego",
    price: "14,90",
    tag: "recomendado",
    category: "Carnes",
    note: "Tempero simples, grelha lenta.",
  },
  {
    name: "Choco Frito com Batata e Salada",
    price: "14,90",
    tag: "popular",
    category: "Do Mar",
    note: "Clássico da casa, estaladiço.",
  },
  {
    name: "Gambas à Guilho",
    price: "10,90",
    tag: "popular",
    category: "Petiscos",
    note: "Alho, azeite, piri-piri. Para dividir.",
  },
];

export const BBQ_MENU = [
  {
    id: "entradas",
    label: "Entradas",
    intro: "Para começar a mesa.",
    items: [
      { name: "Cesto de pão", price: "2,90" },
      { name: "Queijo de cabra", price: "3,90" },
      { name: "Azeitonas", price: "1,30" },
      { name: "Cesto de pão torrado", price: "2,90" },
      { name: "Manteiga / Paté", price: "1,20" },
      { name: "Sopa", price: "2,50" },
    ],
  },
  {
    id: "do-mar",
    label: "Do Mar",
    intro: "Peixe fresco e clássicos da costa.",
    items: [
      { name: "Dourada / Robalo / Salmão", price: "14,90" },
      { name: "Bacalhau à Lagareiro", price: "17,90" },
      { name: "Espetada de lulas e gambas", price: "17,90" },
      { name: "Sardinhas ou carapaus assados", price: "12,90" },
      { name: "Arroz de marisco", price: "16,90" },
      { name: "Bacalhau à Brás", price: "11,90" },
      { name: "Choco frito com batata e salada", price: "14,90", tag: "popular" },
      { name: "Jaquinzinhos com arroz de tomate", price: "12,90" },
    ],
  },
  {
    id: "carnes",
    label: "Carnes",
    intro: "Grelha, madeira e tempo.",
    items: [
      { name: "Costeletas de borrego", price: "14,90", tag: "recomendado" },
      { name: "Bitoque com ovo e batata", price: "11,90" },
      { name: "Frango grelhado", price: "12,90" },
      { name: "Carne de porco à Alentejana", price: "14,90" },
      { name: "Picanha", price: "17,90", tag: "especialidade" },
    ],
  },
  {
    id: "petiscos",
    label: "Petiscos",
    intro: "À portuguesa. Para dividir, conversar e demorar.",
    items: [
      { name: "Pica-pau de vaca", price: "9,90" },
      { name: "Pica-pau de porco", price: "8,90" },
      { name: "Choco frito", price: "9,90" },
      { name: "Gambas à guilho", price: "10,90", tag: "popular" },
      { name: "Mexilhão", price: "13,90" },
      { name: "Ameijoa à Bulhão Pato", price: "18,90" },
      { name: "Moelas estufadas", price: "8,90" },
      { name: "Ovos mexidos com farinheira", price: "8,90" },
      { name: "Camarão cozido", price: "5,90" },
    ],
  },
  {
    id: "saladas",
    label: "Saladas",
    intro: "Frescura e leveza à mesa.",
    items: [
      { name: "Salada mista", price: "6,90" },
      { name: "Salada mista XL", price: "9,90" },
      { name: "Salada de atum", price: "10,90" },
      { name: "Salada de frango", price: "10,90" },
      { name: "Salada de gambas", price: "12,90" },
    ],
  },
  {
    id: "no-pao",
    label: "No Pão",
    intro: "Do balcão direto à mesa.",
    items: [
      { name: "Prego", price: "4,90" },
      { name: "Bifana", price: "3,50" },
      { name: "Cachorro", price: "3,50" },
      { name: "Tosta mista", price: "4,50" },
      { name: "Tosta de frango ou atum", price: "4,90" },
      { name: "Hambúrguer simples", price: "4,90" },
      { name: "Hambúrguer XL", price: "8,90" },
      { name: "Extras", price: "0,50" },
      { name: "Ovo", price: "1,50" },
    ],
  },
  {
    id: "sobremesas",
    label: "Sobremesas",
    intro: "Final doce, caseiro.",
    items: [
      { name: "Mousse / fruta / pudim", price: "3,90" },
      { name: "Tarte de amêndoa", price: "3,90" },
      { name: "Bolo de bolacha", price: "3,90" },
      { name: "Fruta tropical", price: "3,90" },
    ],
  },
  {
    id: "cafetaria",
    label: "Cafetaria",
    intro: "Para fechar a mesa.",
    items: [
      { name: "Café", price: "1,00" },
      { name: "Cappuccino", price: "3,50" },
      { name: "Galão", price: "1,50" },
      { name: "Chá", price: "2,00" },
    ],
  },
  {
    id: "vinhos-sangrias",
    label: "Vinhos & Sangrias",
    intro: "Garrafa, jarro ou copo.",
    items: [
      { name: "Copo vinho", price: "1,90" },
      { name: "Jarro 0,5L", price: "4,95" },
      { name: "Jarro 1L", price: "8,90" },
      { name: "Copo sangria", price: "3,90" },
      { name: "Jarro sangria 1L", price: "13,90" },
      { name: "Sangria frutos vermelhos", price: "16,90" },
    ],
  },
  {
    id: "cocktails-digestivos",
    label: "Cocktails & Digestivos",
    intro: "Digestivos, shots e cocktails clássicos.",
    items: [
      { name: "Bagaceira", price: "3,90" },
      { name: "Brandy", price: "3,90" },
      { name: "Whisky", price: "6,00" },
      { name: "Licor", price: "3,00" },
      { name: "Martini", price: "3,00" },
      { name: "Moscatel", price: "3,00" },
      { name: "Gin / Vodka / Rum / Cocktails", price: "6,50" },
    ],
  },
  {
    id: "bebidas",
    label: "Bebidas",
    intro: "Cerveja, refrigerantes e sumos.",
    items: [
      { name: "Imperial 20cl", price: "1,50" },
      { name: "Caneca 40cl", price: "3,00" },
      { name: "Sidra", price: "4,00" },
      { name: "Média", price: "2,00" },
      { name: "Heineken", price: "2,00" },
      { name: "Água", price: "1,50" },
      { name: "Água com gás", price: "1,50" },
      { name: "Refrigerantes", price: "2,00" },
      { name: "Sumos naturais", price: "3,90" },
    ],
  },
];
